export const Banner = {
  mounted() {
    this.el.querySelector("a").addEventListener("click", (e) => {
      localStorage.setItem("save_search", true);
      this.el.style.display = "none";
    });
    this.showBanner();
  },

  updated() {
    this.showBanner();
  },

  showBanner() {
    if (!localStorage.getItem("save_search")) {
      this.el.style.display = "block";
    }
  }
}
